import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IsForeignUserInfoState, UserInfoState } from '../reducers/userinfo.reducer';

export const selectUserInfoState = createFeatureSelector<UserInfoState>('userInfo');
export const selectIsForeignUserInfoState = createFeatureSelector<IsForeignUserInfoState>('isForeignUserInfo');

export const selectuserInfo = createSelector(selectUserInfoState, (state) => state.userInfo);

export const selectLoading = createSelector(selectUserInfoState, (state) => state.loading);

export const selectError = createSelector(selectUserInfoState, (state) => state.error);

export const selectIsForeignUserInfo = createSelector(selectIsForeignUserInfoState, (state) => state.isForeignUser);

export const selectIsForeignUserLoading = createSelector(selectIsForeignUserInfoState, (state) => state.loading);

export const selectIsForeignUserError = createSelector(selectIsForeignUserInfoState, (state) => state.error);
